import calc from '../../../utils/calc'
import { corporateGroupTableConfigs } from '../../../variables'
import buildMetricValuesHook from '../utils/buildMetricValuesHook'

export const wingitnorthOutliersConfigs = {
  ...corporateGroupTableConfigs,
  totalLaborVarianceHours: 'number',
  avtPercent: 'percent',
  cogsPercent: 'percent',
  laborOvertimeHours: 'number',
  cashOverShort: 'price',
  discountCompsPercent: 'percent',
  voidsPercent: 'percent',
  netSalesPercentageDiffToLastYear: 'percent',
  netSalesPercentageDiffTo7DaysAgo: 'percent',
  checkAverage: 'price',
} as const

const useWingitnorthOutliers = buildMetricValuesHook({
  groupFilterType: 'corporate',
  metrics: {
    codes: [
      'total_labor_variance_hours',
      'avt_percent',
      'cogs_percent',
      'hourly_labor_overtime_minutes',
      'cash_over_short',
      'discount_comps_percent',
      'voids_percent',
      'net_sales_percentage_diff_to_last_year',
      'net_sales_percentage_diff_to_7_days_ago',
      'check_average',
    ],
  },
  handler: (data) => ({
    ...data,
    laborOvertimeHours: calc(data.hourlyLaborOvertimeMinutes, '/', 60) || null,
  }),
})

export default useWingitnorthOutliers
